export const DisclaimerAcceptanceOnline: string[] = [
  "All changes to the chosen payment service must be communicated to Worldline.",
  "Acquiring prices stated in contract cover both purchase and refund transactions",
];
